<template>
  <FireIcon
    v-tooltip="`Auto Book is ignoring capacity for this container`"
    v-bind="$attrs"
  />
</template>
